import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_DEMO_GET',
  GET_SUCCESS: 'STUDENT_DEMO_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_DEMO_GET_FAILURE',

  PATCH: 'STUDENT_DEMO_PATCH',
  PATCH_SUCCESS: 'STUDENT_DEMO_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_DEMO_PATCH_FAILURE',
};

export const patch = actions.patch(
  studentDemoId => `${BASE_URL}/classroom/student-demo/${studentDemoId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
